export default __webpack_public_path__ + "static/media/267.5c92e563.jpg";